import React, { memo } from 'react';
import styled from 'styled-components';

import DeleteButton from './DeleteButton';
import PivotButton from './PivotButton';
import { useResourceValues } from 'src/presentation/hooks/useResource';
import { ModifierValue } from 'src/models/Sidekick/SidekickThreads';
import sidekickFastThreadsResource from 'src/actions/sidekick/sidekickFastThreadsResource';

type ModifierActionsProps = {
  className?: string;
  disabled: boolean;
  moduleId: string;
  modifierId: string;
  modifier: ModifierValue;
  anonModifierId?: string;
};

const ModifierActions = ({
  className,
  disabled,
  moduleId,
  modifierId,
  anonModifierId,
  modifier,
}: ModifierActionsProps) => {
  const { values: threads } = useResourceValues(sidekickFastThreadsResource);

  if (disabled) {
    return null;
  }

  const pivotFlowId = modifier.controlValues?.rule?.then?.pivotFlowID;
  const thread = pivotFlowId ? threads.find(t => t.id === pivotFlowId) : undefined;

  return (
    <ModifierActionsContainer className={className}>
      {thread && <PivotButton id={thread.id} name={thread.name} />}
      <DeleteButton
        moduleId={moduleId}
        modifierId={modifierId}
        anonModifierId={anonModifierId}
        title="Delete Sub-action"
      />
    </ModifierActionsContainer>
  );
};

export const ModifierActionsContainer = styled.div`
  align-items: center;
  display: flex;
  visibility: hidden;
`;

export default memo(ModifierActions);
